import script from "./MainSidebarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebarItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__